/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DashboardDownloadReponse } from '../../models/dashboard-download-reponse';
import { DashboardSearchModel } from '../../models/dashboard-search-model';

export interface DashboardDashboardDownloadPost$Plain$Params {
      body?: DashboardSearchModel
}

export function dashboardDashboardDownloadPost$Plain(http: HttpClient, rootUrl: string, params?: DashboardDashboardDownloadPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<DashboardDownloadReponse>> {
  const rb = new RequestBuilder(rootUrl, dashboardDashboardDownloadPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<DashboardDownloadReponse>;
    })
  );
}

dashboardDashboardDownloadPost$Plain.PATH = '/Dashboard/DashboardDownload';
